import { useState, type ComponentType, type ChangeEvent } from 'react'

interface InputProps {
  label?: string
  placeholder?: string
  value: string
  onChange: (value: string) => void
  icon?: ComponentType<{ size?: number; style?: React.CSSProperties }>
  type?: string
  error?: string
  disabled?: boolean
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void
  suffix?: React.ReactNode
}

export function Input({ label, placeholder, value, onChange, icon: Icon, type = 'text', error, disabled, onKeyDown, suffix }: InputProps) {
  const [focused, setFocused] = useState(false)
  const hasError = !!error

  return (
    <div className="v3-field">
      {label && (
        <label className="v3-field-label" style={hasError ? { color: 'var(--err)' } : undefined}>
          {label}
        </label>
      )}
      <div className={`v3-input-wrap ${hasError ? 'v3-input-error' : ''}`}>
        {Icon && (
          <span className="v3-input-icon" style={hasError ? { color: 'var(--err)' } : focused ? { color: 'var(--accent)' } : undefined}>
            <Icon size={16} />
          </span>
        )}
        <input
          type={type}
          value={value}
          onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
          placeholder={placeholder}
          disabled={disabled}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          onKeyDown={onKeyDown}
          className="v3-input"
          style={{ ...(Icon ? { paddingLeft: 38 } : undefined), ...(suffix ? { paddingRight: 40 } : undefined) }}
        />
        {suffix && <span style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', display: 'flex', zIndex: 1 }}>{suffix}</span>}
      </div>
      {error && <p className="v3-field-error">{error}</p>}
    </div>
  )
}
